import {
  IAuthLoginDto,
  IAuthPasswordResetDto,
  IAuthPasswordResetSendDto,
  IAuthRegisterDto,
} from 'dtos/auth.dto';
import { IAuthLoginResponse } from 'interfaces/auth.interface';
import { IUser } from 'interfaces/user.interface';
import _axios from 'libs/axios';
import _axiosAdmin from 'libs/axios-admin';

export class AuthRepository {
  constructor() {}

  static administratorLogin(body: IAuthLoginDto) {
    return new Promise<IAuthLoginResponse>(async (resolve, reject) => {
      try {
        const { data } = await _axiosAdmin.post<IAuthLoginResponse>(
          '/v1/auth/admin/login',
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static sendResetPassword(body: IAuthPasswordResetSendDto) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post<any>(
          '/v1/auth/send-reset-password',
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static resetPassword(body: IAuthPasswordResetDto) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await _axiosAdmin.post<any>(
          '/v1/auth/reset-password',
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static administratorSendResetPassword(body: IAuthPasswordResetSendDto) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await _axiosAdmin.post<any>(
          '/v1/auth/admin/send-reset-password',
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static administratorResetPassword(body: IAuthPasswordResetDto) {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data } = await _axiosAdmin.post<any>(
          '/v1/auth/admin/reset-password',
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static async userLogin(body: IAuthLoginDto) {
    return new Promise<IAuthLoginResponse>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post<IAuthLoginResponse>(
          '/v1/auth/login',
          body
        );

        // set axios token after login
        _axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${data.accessToken}`;

        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static async userRegister(body: IAuthRegisterDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post<IUser>('/v1/auth/register', body);

        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
}
